import { Box, Typography } from "@material-ui/core";
import Highcharts from "highcharts";
import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import LineChart from "src/components/ScoringChart/Line/LineChart";
import { beautifulTooltip } from "src/components/ScoringChart/tool-utils/BeautifulTooltip";
import { FigureTypography } from "src/components/Typography/TitleTypography";
import OverviewMonitoringWrapper from "src/components/Wrapper/OverviewMonitoringWrapper";
import { INTEREST_TYPE, MONITORING } from "src/config/constants";
import {
  useAnalysisOverviewChartSelector,
  useAnalysisOverviewSelector,
} from "src/context/monitoring/analysisOverviewContext";
import { useParticularPoolsSelector } from "src/context/poolsContext";
import { numberWithCommas, toFixed } from "src/services/utils";

export default function TokenInterestRateOverview() {
  const { pool } = useParams();
  const { fetchInterestRate } = useAnalysisOverviewSelector((state) => state.fetch);
  const interestRate = useAnalysisOverviewChartSelector(MONITORING.OVERVIEW.interestRate, pool);
  const { token: tokenConfig } = useParticularPoolsSelector(pool);

  useEffect(() => {
    fetchInterestRate(
      pool,
      { type: INTEREST_TYPE.DEPOSIT, number: 360, interval: 2, token: "" },
      { active: 2, isCheckMetadata: false }
    );
  }, [pool]);

  const { data, date } = useMemo(() => {
    if (tokenConfig && interestRate) {
      let _data = [];
      let lastTimestamp = "";
      for (var token in interestRate?.data) {
        let name = tokenConfig[token].symbol;
        if (lastTimestamp.length === 0) lastTimestamp = interestRate["data"][token].slice(-1)[0][0];
        _data.push({
          name: name,
          data: interestRate["data"][token].slice(-1)[0][1],
        });
      }
      return {
        data: _data,
        date: Highcharts.dateFormat("%b %e, %Y, %k:%M", lastTimestamp),
      };
    }
    return {
      data: [],
      date: "",
    };
  }, [tokenConfig, interestRate]);

  const { series, isLoading } = useMemo(() => {
    if (tokenConfig && interestRate?.data) {
      let series = [];
      for (var token in interestRate["data"]) {
        let name = tokenConfig[token].symbol;
        series.push({
          name: name,
          data: interestRate["data"][token].map((element) => {
            return [].concat(element);
          }),
        });
      }
      return { series: series, isLoading: false };
    }
    return { series: [], isLoading: true };
  }, [tokenConfig, interestRate]);

  return (
    <OverviewMonitoringWrapper
      isLoading={isLoading}
      title="Token Interest Rate"
      overview="The chart shows the Deposit Rate or Borrow Rate of tokens in the Lending pool."
      to={`/overview-analysis/token-interest-rate/${pool}`}
    >
      <Box width="100%">
        <Box display="flex" flexWrap="wrap">
          {data.map((element, index) => {
            return (
              <FigureTypography
                key={index}
                value={`${numberWithCommas(toFixed(element["data"] * 100, 2))}%`}
                title={element.name}
                index={index}
                style={{ marginRight: "1rem" }}
              />
            );
          })}
        </Box>
        <Typography>{date}</Typography>
      </Box>
      <LineChart
        series={series}
        option={{
          chart: {
            height: "230px",
          },
          xAxis: {
            visible: false,
          },
          ...beautifulTooltip((value) => `${numberWithCommas(toFixed(value * 100, 2))}%`),
        }}
      />
    </OverviewMonitoringWrapper>
  );
}
